import CircularProgress from "components/CircularProgress/CircularProgress";
import { CircularProgressbar } from "components/CircularProgressbar";
import Status from "components/Status/Status";
import moment from "moment-timezone";
import queryString from "query-string";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  HorizontalLine,
  HorizontalLineDivider,
} from "styledComponents/Activity";
import { ColoredBar } from "styledComponents/payroll";
import {
  AssigneeListTableHeaderContainer,
  AssigneeListTableRowContainer,
} from "styledComponents/table";

import avatar5 from "../../../assets/img/avatar_5.svg";
import imageIcon from "../../../assets/img/icons/Image.svg";
import calendarIcon from "../../../assets/img/icons/calender.svg";
import Chat from "../../../assets/img/icons/chat.svg";
import Bean from "../../../assets/img/icons/delete.svg";
import EditIcon from "../../../assets/img/icons/edit.svg";
import audioIcon from "../../../assets/img/icons/play-icon.svg";
import plusIcon from "../../../assets/img/icons/plus_white.svg";
import tick from "../../../assets/img/icons/tick-white-bold.svg";
import evidence from "../../../assets/img/screenshot_1.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import {
  CardText,
  CommonCardContainer,
} from "../../../components/DashboardCards/cardStyles";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import PricingPlan from "../../../components/PricingPlan";
import useAudioDurations from "../../../hooks/useAudioDurations";
import { ListUpperSection } from "../../../styledComponents/ProjectsNew";
import {
  ButtonIcon,
  ColoredButton,
  ColoredButtonWithIcon,
  PrimaryButton,
  WhiteButton,
  WhiteButtonWithIcon,
} from "../../../styledComponents/buttons";
import {
  ClientLocationsTableHeaderContainer,
  ClientLocationsTableRowContainer,
  GeneralInfoItem,
  GeneralInfoSection,
  InnerDivTooltip,
  ToolTipContainer,
  TooltipText,
} from "../../../styledComponents/clients";
import {
  AssignListText,
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonStatusContainer,
  CommonText,
  Container,
  ContentHeader,
  FirstWordRound,
  FormAlert,
  HeaderContainer,
  InputLabel,
  PageTitle,
  ScheduleForContainer,
  ScheduleForItemContainer,
  ScheduleForTitleContainer,
  SemiRoundedButton,
  StatusBadge,
  StatusDot,
  SubtaskTableContainer,
} from "../../../styledComponents/common";
import { CommonImage, TableText } from "../../../styledComponents/common";
import { MemberNameDiv } from "../../../styledComponents/members";
import { TableItem } from "../../../styledComponents/teams";
import { checkHtml, checkUrl, globalDateFormat } from "../../../utils/helper";
import { getMapCircle } from "../../../utils/helper";
import { toHHMMSS } from "../../../utils/helper";
import {
  CardBlock,
  GreenCircle,
  InfoSectionCard,
  LateTag,
  TimelineBorder,
  TimelineContainer,
  TimelineInfoContainer,
  TimelineTextSection,
  UserActivityContainer,
} from "../../FieldServices/RouteMapNew/routeMapStyles";
import {
  CommAssigneesImageNameComp,
  CommImageNameComp,
} from "../../Members/CommonComponents";
import { CommFirstRoundLetterComp } from "../../Teams/CommonComponents";
import SingleLocationMap from "../CreateJob/SingleLocationMap";
import {
  SubTaskTableHeaderContainer,
  SubTaskTableRowContainer,
} from "../CreateJob/createTaskStyles";
import DeleteJobModal from "../DeleteJobModal";
import EvidenceGalleryModal from "../../EvidenceGallaryModal/EvidenceGalleryModal";
import {
  EvidenceIcon,
  EvidenceIconSection,
  StatusBar,
} from "../JobApproval/taskApprovalStyle";
import {
  CallSection,
  EmployeeInfoBlock,
  EvidenceThumbnail,
  LabelTextBlock,
  NoteSection,
  TaskInfoSection,
} from "./taskDetailsStyles";
import LineItemSection from "custom_modules/JobComponents/LineItemSection";
import DocumentUploadSection from "custom_modules/JobComponents/DocumentUploadSection";

const JobDetailsNew = props => {
  const {
    selectedOrganization,
    location,
    history,

    //Job Details
    getJobDetails,
    getJobIsLoading,
    jobDetails,

    //Job Delete
    jobDeleteLoading,
    deleteJob,
  } = props;

  const role = localStorage.getItem("selected_organization_role");
  const user_id = localStorage.getItem("user_id");

  const { t, i18n } = useTranslation();

  // Dynamic paths and labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  const listPath = isOperationType ? "/user/tasks" : "/user/jobs";
  const editPath = isOperationType ? "/user/edit-task" : "/user/edit-job";
  const detailsPageTitle = isOperationType
    ? t("task_details")
    : t("job_details");
  const backToAllItemsLabel = isOperationType
    ? t("back_to_all_tasks")
    : t("back_to_all_jobs");
  const itemLabel = isOperationType ? t("job") : t("task");
  const jobLabel = isOperationType ? t("job") : t("task");
  const itemProgressLabel = isOperationType
    ? t("task_progress")
    : t("job_progress");
  const deleteItemLabel = isOperationType ? t("delete_task") : t("delete_job");
  const workerLabel = isOperationType ? t("project") : t("job");

  // Get organization timezone for time display
  const orgTimezone = selectedOrganization?.timezone || moment.tz.guess();

  const toOrgTimeMoment = timeString => {
    if (!timeString) return null;
    const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(timeString);
    const normalized = hasTimezone ? timeString : `${timeString}Z`;
    return moment(normalized).tz(orgTimezone);
  };

  // Helper function to parse and format time in organization timezone
  const formatTimeInOrgTimezone = timeString => {
    const timeMoment = toOrgTimeMoment(timeString);
    return timeMoment ? timeMoment.format("h:mm a") : "";
  };

  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState(null);

  // Evidence Gallery Modal
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryItems, setGalleryItems] = useState([]);
  const [galleryStartIndex, setGalleryStartIndex] = useState(0);

  // ToolTip
  const [selectIndex, setSelectIndex] = useState(-1);
  const [toolTip, setToolTip] = useState(-1);

  // Pricing Modal
  const [pricingPopup, setPricingPopup] = useState(false);
  // Extract audio URLs for the custom hook (from both assignees and subtasks)
  const assigneeAudioUrls =
    jobDetails?.assignees?.reduce((urls, assignee) => {
      // support multiple evidences
      if (assignee?.evidences && Array.isArray(assignee.evidences)) {
        assignee.evidences.forEach(ev => {
          if (ev?.audio) urls.push(ev.audio);
        });
      } else if (assignee?.evidence?.audio) {
        urls.push(assignee.evidence.audio);
      }
      return urls;
    }, []) || [];

  const subtaskAudioUrls =
    jobDetails?.subtasks?.reduce((urls, subtask) => {
      if (subtask?.evidences && Array.isArray(subtask.evidences)) {
        subtask.evidences.forEach(evidence => {
          if (evidence?.audio) {
            urls.push(evidence.audio);
          }
        });
      }
      return urls;
    }, []) || [];

  const audioUrls = [...assigneeAudioUrls, ...subtaskAudioUrls];
  // Use custom hook for audio durations
  const { getDuration } = useAudioDurations(audioUrls);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (
        // selectedOrganization?.plan?.name === "Standard" ||
        selectedOrganization?.plan?.nick_name === "standard-free"
      ) {
        pricingPopupToggle();
      }

      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        let payload = {
          organization_id: selectedOrganization.id,
          workOrder_id:
            queryParsed[orgType === "service" ? "job_id" : "task_id"],
          job_id: queryParsed.id,
        };
        getJobDetails(payload);
      }
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (jobDetails && jobDetails.location && jobDetails.location.id) {
      const baseUrl = `https://maps.googleapis.com/maps/api/staticmap?key=${process.env.REACT_APP_GOOGLE_MAPS_JAVASCRIPT_API_KEY}&size=600x300&zoom=15&scale=1&language=eng`;
      const markers = `&markers=color:red%7C${jobDetails.location.latitude},${jobDetails.location.longitude}`;
      const path = `&path=fillcolor:0x6f7aff33%7Cweight:2%7Ccolor:0x6f7affff${getMapCircle(
        jobDetails.location.latitude,
        jobDetails.location.longitude,
        jobDetails.location.radius,
      )}`;
      const url = `${baseUrl}${markers}${path}`;

      setImageUrl(url);
      setIsLoading(false);
    }
  }, [jobDetails]);

  const toggle = () => setModal(!modal);

  const pricingPopupToggle = () => setPricingPopup(!pricingPopup);

  // Collect evidences from specific assignee (supports multiple evidences)
  const collectAssigneeEvidences = (assignee) => {
    const evidences = [];
    // Get evidences array (or convert single evidence to array for backward compatibility)
    const assigneeEvidences = assignee?.evidences || (assignee?.evidence ? [assignee.evidence] : []);
    
    assigneeEvidences.forEach((ev, index) => {
      if (ev?.image) {
        evidences.push({
          type: 'image',
          src: ev.image,
          label: `${assignee.first_name} ${assignee.last_name} - Image${assigneeEvidences.length > 1 ? ` ${index + 1}` : ''}`,
        });
      }
      if (ev?.audio) {
        evidences.push({
          type: 'audio',
          src: ev.audio,
          label: `${assignee.first_name} ${assignee.last_name} - Audio${assigneeEvidences.length > 1 ? ` ${index + 1}` : ''}`,
        });
      }
    });
    return evidences;
  };

  // Collect evidences from specific subtask
  const collectSubtaskEvidences = (subtask) => {
    const evidences = [];
    if (subtask?.evidences && Array.isArray(subtask.evidences)) {
      subtask.evidences.forEach((evidence, index) => {
        if (evidence?.image) {
          evidences.push({
            type: 'image',
            src: evidence.image,
            label: `${subtask.name} - Image ${index + 1}`,
          });
        }
        if (evidence?.audio) {
          evidences.push({
            type: 'audio',
            src: evidence.audio,
            label: `${subtask.name} - Audio ${index + 1}`,
          });
        }
      });
    }
    return evidences;
  };

  // Generic gallery opener
  const openGallery = (items, startIndex = 0) => {
    setGalleryItems(items);
    setGalleryStartIndex(startIndex);
    setGalleryOpen(true);
  };

  // Handle assignee evidence click
  const handleAssigneeEvidenceClick = (assignee, evidenceSrc) => {
    const items = collectAssigneeEvidences(assignee);
    const index = items.findIndex(item => item.src === evidenceSrc);
    openGallery(items, index >= 0 ? index : 0);
  };

  // Handle subtask evidence click
  const handleSubtaskEvidenceClick = (subtask, evidenceSrc) => {
    const items = collectSubtaskEvidences(subtask);
    const index = items.findIndex(item => item.src === evidenceSrc);
    openGallery(items, index >= 0 ? index : 0);
  };

  // Handle line item evidence click (wrapper to find subtask)
  const handleLineItemImageClick = (evidenceSrc) => {
    const subtask = jobDetails?.subtasks?.find(st => 
      st.evidences?.some(ev => ev.image === evidenceSrc || ev.audio === evidenceSrc)
    );
    if (subtask) {
      handleSubtaskEvidenceClick(subtask, evidenceSrc);
    }
  };

  // Close gallery and reset state
  const handleCloseGallery = () => {
    setGalleryOpen(false);
    setGalleryItems([]);
    setGalleryStartIndex(0);
  };

  const editJobPage = () => {
    history.push(
      `${editPath}?id=${jobDetails.work_order.id}&${
        orgType === "service" ? "job_id" : "task_id"
      }=${jobDetails.id}`,
    );
  };

  const handleJobDelete = () => {
    if (selectedOrganization && selectedOrganization.id) {
      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        let payload = {
          organization_id: selectedOrganization.id,
          workOrder_id:
            queryParsed[orgType === "service" ? "job_id" : "task_id"],
          job_id: queryParsed.id,
        };
        deleteJob(payload);
      }
      setTimeout(() => {
        setModal(!modal);
        history.push({
          pathname: listPath,
          state: { from: "details" },
        });
      }, 500);
    }
  };
  const toolTipChange = (value, index) => {
    setToolTip(value);
    setSelectIndex(value === -1 ? -1 : index);
  };

  // Helper function to format weekdays
  const formatWeekdays = daysOfWeek => {
    if (!daysOfWeek || !Array.isArray(daysOfWeek) || daysOfWeek.length === 0) {
      return "";
    }
    const dayNames = {
      0: t("sun"),
      1: t("mon"),
      2: t("tue"),
      3: t("wed"),
      4: t("thu"),
      5: t("fri"),
      6: t("sat"),
    };
    const dayLabels = daysOfWeek
      .map(day => dayNames[day] || "")
      .filter(Boolean);
    return dayLabels.join(", ");
  };

  // Helper function to format week number (1st, 2nd, 3rd, 4th)
  const findDateText = date => {
    const dateText = {
      1: "1st",
      2: "2nd",
      3: "3rd",
      21: "21st",
      22: "22nd",
      23: "23rd",
      31: "31st",
    };
    if (dateText[date]) {
      return dateText[date];
    } else {
      return `${date}th`;
    }
  };

  // Helper function to format monthly schedule
  const formatMonthlySchedule = () => {
    if (!jobDetails) return "";

    // Handle days_of_month (specific dates like 1, 15, 31)
    // Only show if is_weekdays_of_month is false or not set
    if (
      jobDetails.days_of_month &&
      jobDetails.days_of_month.length > 0 &&
      !jobDetails.is_weekdays_of_month
    ) {
      const days = jobDetails.days_of_month.map(day => findDateText(day));
      if (days.length === 0) {
        return "";
      }
      if (days.length === 1) {
        return `${days[0]} of each month`;
      }
      const lastEntry = days.pop();
      return `${days.join(", ")} and ${lastEntry} of each month`;
    }

    // Handle weekdays_of_month (grid positions 0-27 representing week+day combinations)
    // Grid layout: Week 1 (0-6), Week 2 (7-13), Week 3 (14-20), Week 4 (21-27)
    // Each week: Monday (0), Tuesday (1), Wednesday (2), Thursday (3), Friday (4), Saturday (5), Sunday (6)
    if (
      jobDetails.weekdays_of_month &&
      jobDetails.weekdays_of_month.length > 0 &&
      jobDetails.is_weekdays_of_month
    ) {
      const FULL_WEEK_DAYS = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];

      const selections = [];
      jobDetails.weekdays_of_month.forEach(index => {
        const weekNumber = Math.floor(index / 7) + 1; // 1-4
        const dayIndex = index % 7; // 0-6 (Mon-Sun)
        const dayLabel = FULL_WEEK_DAYS[dayIndex];
        if (dayLabel) {
          const weekLabel = findDateText(weekNumber);
          selections.push(`${weekLabel} ${dayLabel}`);
        }
      });

      if (selections.length === 0) {
        return "";
      }
      if (selections.length === 1) {
        return `${selections[0]} of each month`;
      }
      const lastEntry = selections.pop();
      return `${selections.join(", ")} and ${lastEntry} of each month`;
    }

    return "";
  };

  // Helper function to check if times are the default "whole day" times (00:00 to 23:59)
  const isWholeDayTime = (startTime, endTime) => {
    if (!startTime || !endTime) return false;
    const startInOrgTz = toOrgTimeMoment(startTime);
    const endInOrgTz = toOrgTimeMoment(endTime);
    if (!startInOrgTz || !endInOrgTz) return false;
    return (
      startInOrgTz.format("HH:mm") === "00:00" &&
      endInOrgTz.format("HH:mm") === "23:59"
    );
  };

  // Helper function to determine if we should show "Anytime" or actual times
  const shouldShowAnytime = () => {
    // If is_anytime is true, always show "Anytime" regardless of actual times
    if (jobDetails.is_anytime) {
      return true;
    }
    // If is_anytime is false, show actual times
    return false;
  };

  const jobStartOrgMoment = toOrgTimeMoment(jobDetails?.start_time);
  const jobEndOrgMoment = toOrgTimeMoment(jobDetails?.end_time);

  return (
    <div className="content">
      <EvidenceGalleryModal
        isOpen={galleryOpen}
        items={galleryItems}
        startIndex={galleryStartIndex}
        onClose={handleCloseGallery}
      />
      <PricingPlan
        isOpen={pricingPopup}
        toggle={pricingPopupToggle}
        popupText="You don't have permission to this feature."
        popupTitle="Upgrade to Elite to access this feature"
        history={history}
        backRoute="/user/dashboard"
        onlyElite
      />
      <DeleteJobModal
        isOpen={modal}
        toggle={toggle}
        handleDelete={handleJobDelete}
        isLoading={jobDeleteLoading}
      />
      {/* <PageTitle>{detailsPageTitle}</PageTitle> */}
      <ContentHeader>
        <BackButtonComponent
          onClick={() => props.history.push(listPath)}
          subTitle={backToAllItemsLabel}
        />
      </ContentHeader>
      <Container marginTop="12px" padding="30px" gap="20px">
        {getJobIsLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            {/* upper section  */}
            <CommonGrid gap="20px" columns="1fr 1fr">
              {/* left side */}
              <CommonFlex
                alignItems="start"
                flexFlow="column"
                justifyContent="start"
                width="100%"
              >
                {/* job id and status section */}
                <CommonFlex
                  alignItems="start"
                  justifyContent="space-between"
                  flexFlow="row"
                  gap="5px"
                  width="100%"
                >
                  <CommonText margin="0 0 10px 0" name title fontSize="14px">
                    {jobLabel}: #
                    {jobDetails?.job_code ||
                      `#${jobDetails?.id?.slice(0, 8) || ""}`}
                  </CommonText>
                  <CommonStatusContainer>
                    <StatusDot status={jobDetails?.status?.toLowerCase()} />
                    <CommonText name title fontSize="13px">
                      {jobDetails?.status
                        ? jobDetails.status.charAt(0).toUpperCase() +
                          jobDetails.status.slice(1).replace(/_/g, " ")
                        : "-"}
                    </CommonText>
                  </CommonStatusContainer>
                </CommonFlex>

                {/* job name section */}
                <CommonText margin="0 0 10px 0" name title fontSize="20px">
                  {jobDetails?.name || "-"}
                </CommonText>

                {/* worker and status section */}
                <CommonGrid
                  columns="1fr 1fr"
                  gap="10px"
                  style={{ width: "100%" }}
                >
                  {orgType === "operation" && <CommonFlex
                    alignItems="start"
                    flexFlow="column"
                    gap="5px"
                    style={{ marginBottom: "10px" }}
                  >
                    <CommonText name fontSize="14px">
                      {workerLabel}:
                    </CommonText>
                    <CommonText name title fontSize="13px">
                      {jobDetails?.work_order?.name || "-"}
                    </CommonText>
                  </CommonFlex>}

                  <CommonFlex
                    alignItems="start"
                    flexFlow="column"
                    gap="5px"
                    style={{ marginBottom: "10px" }}
                  >
                    <CommonText name fontSize="14px">
                      Job No:
                    </CommonText>
                    <CommonText name title fontSize="13px">
                      {jobDetails?.job_no || "-"}
                    </CommonText>
                  </CommonFlex>
                </CommonGrid>

                {/* progress and customer section */}
                <CommonGrid
                  columns={orgType === "operation" ? "1fr" : "1fr 1fr"}
                  gap="10px"
                  style={{ width: "100%" }}
                  alignItem="flex-start"
                >
                  {orgType === "operation" ? (
                    // For operation type: show job progress in place of customer
                    <CommonFlex
                      alignItems="flex-start"
                      flexFlow="column"
                      gap="5px"
                      style={{ marginBottom: "10px" }}
                    >
                      <CommonText name fontSize="14px">
                        {itemProgressLabel}:
                      </CommonText>
                      <CircularProgress
                        percent={jobDetails?.percentage_complete || 0}
                        size={50}
                        strokeWidth={4}
                      />
                    </CommonFlex>
                  ) : (
                    // For service type: show both customer and job progress
                    <>
                      <CommonFlex
                        alignItems="start"
                        flexFlow="column"
                        gap="10px"
                        style={{ marginBottom: "10px" }}
                      >
                        <CommonText
                          style={{ margin: "0px" }}
                          name
                          fontSize="14px"
                        >
                          Customer:
                        </CommonText>
                        <CommImageNameComp
                          imgSource={
                            jobDetails?.work_order?.client_image || avatar5
                          }
                          name={jobDetails?.work_order?.client_name || "-"}
                          size="40px"
                          fontSize="13px"
                          index={2}
                          color={jobDetails?.work_order?.client_color}
                          email={jobDetails?.work_order?.client_email}
                          showAddDesignation = {false}
                        />
                      </CommonFlex>

                      <CommonFlex
                        alignItems="flex-start"
                        flexFlow="column"
                        gap="5px"
                        style={{ marginBottom: "10px" }}
                      >
                        <CommonText name fontSize="14px">
                          {itemProgressLabel}:
                        </CommonText>
                        <CircularProgress
                          percent={jobDetails?.percentage_complete || 0}
                          size={50}
                          strokeWidth={4}
                        />
                      </CommonFlex>
                    </>
                  )}
                </CommonGrid>
                {/* description section */}
                {jobDetails?.description && (
                  <CommonFlex alignItems="start" flexFlow="column" gap="5px">
                    <CommonText name title fontSize="14px">
                      Description:{" "}
                    </CommonText>
                    <CommonText name fontSize="13px">
                      {jobDetails.description}
                    </CommonText>
                  </CommonFlex>
                )}
              </CommonFlex>

              {/* right side */}
              <CommonFlex alignItems="start" flexFlow="column">
                {/* status and option section */}
                <CommonGrid
                  alignContent="flex-start"
                  gap="20px"
                  style={{ width: "100%" }}
                  columns="1fr 1fr"
                >
                  <div> </div>

                  {/* <CommonFlex alignItems="end" flexFlow="row" gap="5px"> */}

                  <CommonFlex
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    flexFlow="row"
                  >
                    {selectedOrganization &&
                    selectedOrganization.role &&
                    (selectedOrganization.role === "admin" ||
                      selectedOrganization.role === "owner") &&
                    jobDetails &&
                    jobDetails.status &&
                    (jobDetails.status === "unscheduled" ||
                      jobDetails.status === "scheduled" ||
                      jobDetails.status === "ready to dispatch" ||
                      jobDetails.status === "totally missed") ? (
                      <>
                        <WhiteButtonWithIcon
                          type="delete"
                          fontSize="14px"
                          onClick={toggle}
                        >
                          <ButtonIcon src={Bean} alt="" />
                          {/* {deleteItemLabel} */}
                          Delete
                        </WhiteButtonWithIcon>
                        <WhiteButtonWithIcon
                          type="edit"
                          fontSize="14px"
                          onClick={editJobPage}
                        >
                          <ButtonIcon src={EditIcon} alt="" />
                          Edit
                        </WhiteButtonWithIcon>
                      </>
                    ) : (
                      <></>
                    )}
                  </CommonFlex>
                  {/* </CommonFlex> */}
                </CommonGrid>

                {/* location section   */}
                <CommonGrid style={{ width: "100%" }} columns="1fr" gap="20px">
                  <CommonText name fontSize="14px">
                    Location:
                  </CommonText>
                  {jobDetails && jobDetails.location ? (
                    <CommonCardContainer>
                      <CommonImage
                        style={{ borderRadius: "5px" }}
                        src={imageUrl}
                        alt="map"
                      />
                      <CommonText>{jobDetails?.location?.address}</CommonText>
                    </CommonCardContainer>
                  ) : (
                    <CommonText style={{ marginTop: "0px" }}>
                      No location available
                    </CommonText>
                  )}
                </CommonGrid>
              </CommonFlex>
            </CommonGrid>

            <HorizontalLineDivider />

            {/* middle section   */}
            <CommonGrid gap="20px" alignItem="flex-start" columns="1fr 1fr">
              <CommonFlex
                width="100%"
                alignItems="flex-start"
                flexFlow="column"
                gap="10px"
              >
                <CommonText name fontSize="14px">
                  Schedule for
                </CommonText>
                {jobDetails && jobDetails.status === "unscheduled" && (
                  <>
                    {/* Unscheduled Schedule */}
                    <ScheduleForContainer
                      style={{
                        marginRight: "10px",
                        width: "100%",
                        gridTemplateColumns: "1fr 150px",
                      }}
                    >
                      <ScheduleForItemContainer>
                        <CommonText name title fontSize="16px">
                          {" "}
                          Unscheduled Job
                        </CommonText>
                      </ScheduleForItemContainer>
                      <ColoredButton
                        style={{ width: "max-content", borderRadius: "30px" }}
                        onClick={editJobPage}
                      >
                        Schedule Now
                      </ColoredButton>
                    </ScheduleForContainer>
                  </>
                )}

                {jobDetails &&
                  jobDetails.schedule_type &&
                  jobDetails.status !== "unscheduled" && (
                    <>
                      {/* Daily Schedule */}
                      {jobDetails.schedule_type === "daily" && (
                        <ScheduleForContainer>
                          <ScheduleForItemContainer>
                            <CommonFlex gap="10px" alignItems="flex-start">
                              <CommonImage
                                src={calendarIcon}
                                alt="calendar"
                                width="20px"
                                height="20px"
                              />
                              <CommonText name title fontSize="16px">
                                {jobDetails.start_time
                                  ? moment(jobDetails.start_time + "Z")
                                      .tz(orgTimezone)
                                      .format("D MMM YYYY")
                                  : "-"}
                              </CommonText>
                            </CommonFlex>

                            {shouldShowAnytime() ? (
                              <CommonFlex gap="10px" alignItems="flex-start">
                                <CommonText name fontSize="14px">
                                  Time:
                                </CommonText>
                                <CommonText name title fontSize="14px">
                                  Anytime of this day
                                </CommonText>
                              </CommonFlex>
                            ) : (
                              jobDetails.start_time &&
                              jobDetails.end_time && (
                                <CommonFlex gap="10px" alignItems="flex-start">
                                  <CommonText name fontSize="14px">
                                    Start Time:
                                  </CommonText>
                                  <CommonText name title fontSize="14px">
                                    {formatTimeInOrgTimezone(
                                      jobDetails.start_time,
                                    )}
                                  </CommonText>
                                  <CommonText name fontSize="14px">
                                    End Time:
                                  </CommonText>
                                  <CommonText name title fontSize="14px">
                                    {formatTimeInOrgTimezone(
                                      jobDetails.end_time,
                                    )}
                                  </CommonText>
                                </CommonFlex>
                              )
                            )}

                            {jobDetails.end_time && (
                              <CommonFlex gap="10px" alignItems="flex-start">
                                <CommonText name fontSize="14px">
                                  Ending Date:
                                </CommonText>
                                <CommonText name title fontSize="14px">
                                  {moment(jobDetails.end_time + "Z")
                                    .tz(orgTimezone)
                                    .format("D MMM YYYY")}
                                </CommonText>
                              </CommonFlex>
                            )}
                          </ScheduleForItemContainer>
                          {jobDetails.recurring && (
                            <SemiRoundedButton>Daily</SemiRoundedButton>
                          )}
                        </ScheduleForContainer>
                      )}

                      {/* Weekly Schedule */}
                      {jobDetails.schedule_type === "weekly" && (
                        <ScheduleForContainer>
                          <ScheduleForItemContainer>
                            <CommonFlex gap="10px" alignItems="flex-start">
                              <CommonImage
                                src={calendarIcon}
                                alt="calendar"
                                width="20px"
                                height="20px"
                              />
                              {/* Show date similar to daily schedule */}
                              <CommonText name title fontSize="16px">
                                {jobDetails.start_time
                                  ? moment(jobDetails.start_time + "Z")
                                      .tz(orgTimezone)
                                      .format("D MMM YYYY")
                                  : jobDetails.end_time
                                  ? moment(jobDetails.end_time + "Z")
                                      .tz(orgTimezone)
                                      .format("D MMM YYYY")
                                  : "-"}
                              </CommonText>
                            </CommonFlex>

                            {shouldShowAnytime() ? (
                              <CommonFlex gap="10px" alignItems="flex-start">
                                <CommonText name fontSize="14px">
                                  Time:
                                </CommonText>
                                <CommonText name title fontSize="14px">
                                  Anytime of this day
                                </CommonText>
                              </CommonFlex>
                            ) : (
                              jobDetails.start_time &&
                              jobDetails.end_time && (
                                <CommonFlex gap="10px" alignItems="flex-start">
                                  <CommonText name fontSize="14px">
                                    Start Time:
                                  </CommonText>
                                  <CommonText name title fontSize="14px">
                                    {formatTimeInOrgTimezone(
                                      jobDetails.start_time,
                                    )}
                                  </CommonText>
                                  <CommonText name fontSize="14px">
                                    End Time:
                                  </CommonText>
                                  <CommonText name title fontSize="14px">
                                    {formatTimeInOrgTimezone(
                                      jobDetails.end_time,
                                    )}
                                  </CommonText>
                                </CommonFlex>
                              )
                            )}

                            {jobDetails.end_time && (
                              <CommonFlex gap="10px" alignItems="flex-start">
                                <CommonText name fontSize="14px">
                                  Ending Date:
                                </CommonText>
                                <CommonText name title fontSize="14px">
                                  {moment(jobDetails.end_time + "Z")
                                    .tz(orgTimezone)
                                    .format("D MMM YYYY")}
                                </CommonText>
                              </CommonFlex>
                            )}
                          </ScheduleForItemContainer>
                          <SemiRoundedButton>Weekly</SemiRoundedButton>
                        </ScheduleForContainer>
                      )}

                      {/* Monthly Schedule */}
                      {jobDetails.schedule_type === "monthly" && (
                        <ScheduleForContainer>
                          <ScheduleForItemContainer>
                            <CommonFlex gap="10px" alignItems="flex-start">
                              <CommonImage
                                src={calendarIcon}
                                alt="calendar"
                                width="20px"
                                height="20px"
                              />
                              {/* Show date similar to daily schedule */}
                              <CommonText name title fontSize="16px">
                                {jobDetails.start_time
                                  ? moment(jobDetails.start_time + "Z")
                                      .tz(orgTimezone)
                                      .format("D MMM YYYY")
                                  : jobDetails.end_time
                                  ? moment(jobDetails.end_time + "Z")
                                      .tz(orgTimezone)
                                      .format("D MMM YYYY")
                                  : "-"}
                              </CommonText>
                            </CommonFlex>

                            {shouldShowAnytime() ? (
                              <CommonFlex gap="10px" alignItems="flex-start">
                                <CommonText name fontSize="14px">
                                  Time:
                                </CommonText>
                                <CommonText name title fontSize="14px">
                                  Anytime of this day
                                </CommonText>
                              </CommonFlex>
                            ) : (
                              jobDetails.start_time &&
                              jobDetails.end_time && (
                                <CommonFlex gap="10px" alignItems="flex-start">
                                  <CommonText name fontSize="14px">
                                    Start Time:
                                  </CommonText>
                                  <CommonText name title fontSize="14px">
                                    {formatTimeInOrgTimezone(
                                      jobDetails.start_time,
                                    )}
                                  </CommonText>
                                  <CommonText name fontSize="14px">
                                    End Time:
                                  </CommonText>
                                  <CommonText name title fontSize="14px">
                                    {formatTimeInOrgTimezone(
                                      jobDetails.end_time,
                                    )}
                                  </CommonText>
                                </CommonFlex>
                              )
                            )}

                            {jobDetails.end_time && (
                              <CommonFlex gap="10px" alignItems="flex-start">
                                <CommonText name fontSize="14px">
                                  Ending Date:
                                </CommonText>
                                <CommonText name title fontSize="14px">
                                  {moment(jobDetails.end_time + "Z")
                                    .tz(orgTimezone)
                                    .format("D MMM YYYY")}
                                </CommonText>
                              </CommonFlex>
                            )}
                          </ScheduleForItemContainer>
                          <SemiRoundedButton>Monthly</SemiRoundedButton>
                        </ScheduleForContainer>
                      )}
                    </>
                  )}
              </CommonFlex>

              {/* Assignees section */}
              {jobDetails &&
                jobDetails.assignees &&
                jobDetails.assignees.length > 0 && (
                  <CommonFlex
                    flexFlow="column"
                    alignItems="flex-start"
                    gap="0px"
                    width="100%"
                  >
                    <CommonText name margin="0 0 10px 0" fontSize="14px">
                      Assignee list
                    </CommonText>
                    {jobDetails &&
                      jobDetails.assignees &&
                      jobDetails.assignees.length > 0 && (
                        <>
                          <AssigneeListTableHeaderContainer
                            justifyContent="flex-start"
                            columns="200px 120px 120px 100px auto"
                            //                           columns="
                            //   minmax(150px, auto)
                            //   minmax(100px, auto)
                            //   minmax(100px, auto)
                            //   minmax(120px, auto)
                            //   minmax(120px, auto)
                            // "
                          >
                            <TableItem>
                              <TableText>Assignee</TableText>
                            </TableItem>
                            <TableItem>
                              <TableText>Check In</TableText>
                            </TableItem>
                            <TableItem>
                              <TableText>Check Out</TableText>
                            </TableItem>
                            <TableItem>
                              <TableText>Status</TableText>
                            </TableItem>
                            <TableItem>
                              <TableText>Evidence</TableText>
                            </TableItem>
                          </AssigneeListTableHeaderContainer>
                          {jobDetails?.assignees?.map((assignee, index) => {
                            if (role === "member" && user_id !== assignee.id) {
                              return null;
                            }
                            return (
                              <AssigneeListTableRowContainer
                                key={assignee.id || index}
                                justifyContent="flex-start"
                                columns="200px 120px 120px 100px auto"
                                //                               columns="
                                //   minmax(150px, auto)
                                //   minmax(100px, auto)
                                //   minmax(100px, auto)
                                //   minmax(120px, auto)
                                //   minmax(120px, auto)
                                // "
                              >
                                {/* Assignee name */}
                                <TableItem>
                                  <div key={assignee.id}>
                                    <MemberNameDiv
                                      onClick={() =>
                                        props.history.push(
                                          `/user/member-details?id=${assignee.id}`,
                                        )
                                      }
                                    >
                                      <CommImageNameComp
                                        imgSource={assignee.avatar || avatar5}
                                        name={`${assignee.first_name} ${assignee.last_name}`}
                                        size="36px"
                                        fontSize="13px"
                                        index={index}
                                        color={assignee.color}
                                        hoverUnderline
                                        showAddDesignation = {false}
                                        designation={assignee.designation}
                                      />
                                    </MemberNameDiv>
                                  </div>
                                </TableItem>
                                {/* Clock In */}
                                <TableItem>
                                  <CommonFlex
                                    direction="row"
                                    alignItems="center"
                                    gap="0px"
                                  >
                                    {assignee.checkedin &&
                                    assignee.checkedin.timestamp
                                      ? moment
                                          .unix(assignee.checkedin.timestamp)
                                          .format("h:mm a")
                                      : "-"}
                                    {assignee.checkedin &&
                                      assignee.checkedin.timestamp &&
                                      (jobDetails.is_anytime === "true" ||
                                      jobDetails.is_anytime === true ? (
                                        <GreenCircle>
                                          <img src={tick} alt="" width="100%" />
                                        </GreenCircle>
                                      ) : moment
                                          .unix(assignee.checkedin.timestamp)
                                          .isAfter(
                                            moment(
                                              jobDetails.start_time + "Z",
                                            ).tz(orgTimezone),
                                          ) ? (
                                        <LateTag>{t("late")}</LateTag>
                                      ) : (
                                        <GreenCircle>
                                          <img src={tick} alt="" width="100%" />
                                        </GreenCircle>
                                      ))}
                                  </CommonFlex>
                                </TableItem>
                                {/* Clock Out */}
                                <TableItem>
                                  <CommonFlex
                                    direction="row"
                                    alignItems="center"
                                    gap="0px"
                                  >
                                    {assignee.checkedout &&
                                    assignee.checkedout.timestamp
                                      ? moment
                                          .unix(assignee.checkedout.timestamp)
                                          .format("h:mm a")
                                      : "-"}
                                    {assignee.checkedout &&
                                      assignee.checkedout.timestamp &&
                                      (jobDetails.is_anytime === "true" ||
                                      jobDetails.is_anytime === true ? (
                                        <GreenCircle>
                                          <img src={tick} alt="" width="100%" />
                                        </GreenCircle>
                                      ) : moment
                                          .unix(assignee.checkedout.timestamp)
                                          .isAfter(
                                            moment(
                                              jobDetails.end_time + "Z",
                                            ).tz(orgTimezone),
                                          ) ? (
                                        <LateTag>{t("late")}</LateTag>
                                      ) : (
                                        <GreenCircle>
                                          <img src={tick} alt="" width="100%" />
                                        </GreenCircle>
                                      ))}
                                  </CommonFlex>
                                </TableItem>
                                {/* Status */}
                                <TableItem>
                                  <Status
                                    status={
                                      assignee.checkedin &&
                                      assignee.checkedin.timestamp &&
                                      (!assignee.checkedout ||
                                        !assignee.checkedout.timestamp)
                                        ? "in_progress"
                                        : assignee.status
                                    }
                                  />
                                </TableItem>
                                {/* Evidence */}
                                <TableItem padding="8px 10px">
                                  <EvidenceIconSection gap="15px">
                                {(() => {
                                  const allEvidences = assignee?.evidences || (assignee?.evidence ? [assignee.evidence] : []);
                                  const visibleEvidences = allEvidences.slice(0, 4);
                                  const hasMore = allEvidences.length > 4;
                                  
                                  return (
                                    <>
                                      {visibleEvidences.map((ev, evIndex) => (
                                        <Fragment key={`assignee-evidence-${index}-${evIndex}`}>
                                          {ev?.image && (
                                            <EvidenceIcon
                                              onClick={() =>
                                                
                                                handleAssigneeEvidenceClick(assignee, ev.image)
                          
                                              }
                                            >
                                              <CommonImage
                                                src={ev.image}
                                                alt=""
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                }}
                                              />
                                            </EvidenceIcon>
                                          )}
                                          {ev?.audio && (
                                            <EvidenceIcon
                                              onClick={() =>
                                                handleAssigneeEvidenceClick(assignee, ev.audio)
                                              }
                                            >
                                              <CommonImage
                                                src={audioIcon}
                                                alt=""
                                                size="20px"
                                              />
                                              <span
                                                style={{
                                                  fontSize: "10px",
                                                  color: "#2266EF",
                                                  fontWeight: "600",
                                                }}
                                              >
                                                {getDuration(ev.audio)}
                                              </span>
                                            </EvidenceIcon>
                                          )}
                                        </Fragment>
                                      ))}
                                      {hasMore && (
                                        <EvidenceIcon
                                          onClick={() => {
                                            const fifthEvidence = allEvidences[4];
                                            const evidenceSrc = fifthEvidence?.image || fifthEvidence?.audio;
                                            if (evidenceSrc) {
                                              handleAssigneeEvidenceClick(assignee, evidenceSrc);
                                            }
                                          }}
                                          style={{
                                            backgroundColor: '#2266EF',
                                            color: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                          }}
                                        >
                                          +{allEvidences.length - 4}
                                        </EvidenceIcon>
                                      )}
                                      {allEvidences.length === 0 && (
                                        <CommonText fontSize="12px">-</CommonText>
                                      )}
                                    </>
                                  );
                                })()}
                              </EvidenceIconSection>
                                </TableItem>
                              </AssigneeListTableRowContainer>
                            );
                          })}
                        </>
                      )}
                  </CommonFlex>
                )}

              {/* middle section  end  */}
            </CommonGrid>
            <HorizontalLineDivider />
            {/* Supervisor Note */}
            {jobDetails &&
              (jobDetails.employee_note || jobDetails.supervisor_note) && (
                <NoteSection style={{ borderTop: "none", padding: "0 30px" }}>
                  {jobDetails && jobDetails.employee_note && (
                    <>
                      <CommonText name fontSize="14px">
                        {t("employee_note")}
                      </CommonText>
                      <CommonText>{jobDetails.employee_note}</CommonText>
                    </>
                  )}
                  {/* <HorizontalLineDivider /> */}
                </NoteSection>
              )}

            {/* bottom section  start  */}
            {/* Subtask section  start  */}
            {jobDetails && orgType === "operation" &&
              jobDetails.subtasks &&
              jobDetails.subtasks.length > 0 && (
                <>
                  <HorizontalLineDivider />
                  <SubtaskTableContainer bgColor="#EDF8FE">
                    <CommonText title name margin="0 0 16px 0" fontSize="14px">
                      Subtasks:
                    </CommonText>
                    <SubTaskTableHeaderContainer
                      style={{ width: "100%", borderRadius: "5px 5px 0 0" }}
                      columns="1fr 1fr 1fr 1fr 1fr"
                    >
                      <TableItem>
                        <TableText>Subtask Name</TableText>
                      </TableItem>
                      <TableItem>
                        <TableText>Description</TableText>
                      </TableItem>
                      <TableItem>
                        <TableText>Evidence</TableText>
                      </TableItem>
                      <TableItem>
                        <TableText>Status</TableText>
                      </TableItem>
                      <TableItem>
                        <TableText>Note</TableText>
                      </TableItem>
                    </SubTaskTableHeaderContainer>
                    {jobDetails.subtasks.map((subtask, index) => (
                      <SubTaskTableRowContainer
                        key={subtask.id || index}
                        style={{ width: "100%" }}
                        columns="1fr 1fr 1fr 1fr 1fr"
                      >
                        <TableItem>{subtask.name || "-"}</TableItem>
                        <TableItem>{subtask.description || "-"}</TableItem>
                        <TableItem>
                          <EvidenceIconSection>
                            {subtask.evidences &&
                              subtask.evidences.length > 0 &&
                              subtask.evidences.map((evidence, evIndex) => (
                                <Fragment
                                  key={`subtask-${
                                    subtask.id || index
                                  }-evidence-${evidence.id || evIndex}`}
                                >
                                  {evidence.image && (
                                    <EvidenceIcon
                                      onClick={() =>
                                        handleSubtaskEvidenceClick(subtask, evidence.image)
                                      }
                                      // onMouseEnter={() =>
                                      //   toolTipChange(1, `${index}-${evIndex}`)
                                      // }
                                      // onMouseLeave={() => toolTipChange(-1)}
                                    >
                                      <CommonImage
                                        src={evidence.image}
                                        alt="img"
                                        // size="28px"
                                      />
                                      {/* {selectIndex === `${index}-${evIndex}` &&
                                        toolTip === 1 && (
                                          <ToolTipContainer
                                            style={{
                                              position: "relative",
                                              top: "-60px",
                                            }}
                                          >
                                            <InnerDivTooltip>
                                              <img
                                                src={Chat}
                                                alt="chat"
                                                width="64px"
                                              />
                                              <TooltipText>Image</TooltipText>
                                            </InnerDivTooltip>
                                          </ToolTipContainer>
                                        )} */}
                                    </EvidenceIcon>
                                  )}
                                  {evidence.audio && (
                                    <EvidenceIcon
                                      onClick={() =>
                                        handleSubtaskEvidenceClick(subtask, evidence.audio)
                                      }
                                      // onMouseEnter={() =>
                                      //   toolTipChange(2, `${index}-${evIndex}`)
                                      // }
                                      // onMouseLeave={() => toolTipChange(-1)}
                                    >
                                      <CommonImage
                                        src={audioIcon}
                                        alt=""
                                        // size="25px"
                                      />
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          color: "#2266EF",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {getDuration(evidence.audio)}
                                      </span>
                                      {/* {selectIndex === `${index}-${evIndex}` &&
                                        toolTip === 2 && (
                                          <ToolTipContainer
                                            style={{
                                              position: "relative",
                                              top: "-57px",
                                            }}
                                          >
                                            <InnerDivTooltip>
                                              <img
                                                src={Chat}
                                                alt="chat"
                                                width="64px"
                                              />
                                              <TooltipText>Audio</TooltipText>
                                            </InnerDivTooltip>
                                          </ToolTipContainer>
                                        )} */}
                                    </EvidenceIcon>
                                  )}
                                </Fragment>
                              ))}
                            {(!subtask.evidences ||
                              subtask.evidences.length === 0) && (
                              <CommonText fontSize="12px">-</CommonText>
                            )}
                          </EvidenceIconSection>
                        </TableItem>
                        <TableItem>
                          <CommonFlex
                            flexFlow="column"
                            gap="3px"
                            alignItems="flex-start"
                          >
                            {subtask.status && (
                              <Status status={subtask.status} />
                            )}
                            {subtask.percentage_complete && (
                              <CommonText
                                fontSize="11px"
                                style={{ color: "#666" }}
                              >
                                {parseFloat(
                                  subtask.percentage_complete,
                                ).toFixed(0)}
                                % complete
                              </CommonText>
                            )}
                            {!subtask.status &&
                              !subtask.percentage_complete && (
                                <CommonText fontSize="12px">-</CommonText>
                              )}
                          </CommonFlex>
                        </TableItem>
                        <TableItem>
                          <CommonText>
                            {subtask.evidences.note || "-"}
                          </CommonText>
                        </TableItem>
                      </SubTaskTableRowContainer>
                    ))}
                  </SubtaskTableContainer>
                </>
              )}
            {jobDetails &&
              orgType !== "operation" &&
              jobDetails.subtasks &&
              jobDetails.subtasks.length > 0 && (
                <>
                  {/* <HorizontalLineDivider /> */}
                  <LineItemSection
                    pageType="detail"
                    subtasks={jobDetails?.subtasks}
                    onImageClick={handleLineItemImageClick}
                    onAudioClick={handleLineItemImageClick}
                    getDuration={getDuration}
                  />
                </>
              )}

            {jobDetails &&
              orgType !== "operation" &&
              jobDetails?.job_documents &&
              jobDetails?.job_documents.length > 0 && (
                <>
                  <HorizontalLineDivider />
                  <CommonCardContainer bgColor="#EDF8FE">
                  <DocumentUploadSection
                      pageType="detail"
                      documents={jobDetails?.job_documents}
                    />
                  </CommonCardContainer>
                </>
              )}
          </>
        )}
      </Container>
    </div>
  );
};

export default JobDetailsNew;
